import { api } from '../../../../services/api'

export async function atualizarPedidoPago({ numero_nota }) {
  try {
    const response = await api.get(`${process.env.REACT_APP_BASE_URL}/site/v2/pedido/atualiza-pedido-pago/${numero_nota}`)

    return response
  } catch (error) {
    console.log(error)
  }
}

export async function baixaManual({ numero_nota, valor_nota, codigo_empresa }) {
  try {
    const response = await api.post('https://api.innovationbrindes.com.br/api/site/v2/interno-devs/baixar-pedido-manualmente', {
      numero_nota,
      valor_nota,
      codigo_empresa,
    })

    return response
  } catch (error) {
    console.log(error)
  }
}

export async function removerbaixaPedido({ numero_nota }) {
  try {
    const response = await api.get(`${process.env.REACT_APP_BASE_URL}/site/v2/interno-devs/remover-baixa-pedido/${numero_nota}`)

    return response
  } catch (error) {
    console.log(error)
  }
}

export async function atualizaPesoTGFCAB({ numero_nota }) {
  try {
    const response = await api.get(`${process.env.REACT_APP_BASE_URL}/site/v2/pedido/atualiza-peso-info-nota/${numero_nota}`)

    return response
  } catch (error) {
    console.log(error)
  }
}

export async function baixarNota({ numero_nota }) {
  try {
    const link = document.createElement('a')
    link.href = `${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/download-nota/${numero_nota}`
    link.setAttribute('download', `${numero_nota}-nota.pdf`)
    link.download = `${numero_nota}-nota.pdf`

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    return { success: true }
  } catch (error) {
    console.log(error)
    return { success: false }
  }
}

export async function baixarXml({ numero_nota }) {
  try {
    const link = document.createElement('a')
    link.href = `${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/download-xml/${numero_nota}`
    link.setAttribute('download', `${numero_nota}-xml.xml`)
    link.download = `${numero_nota}-nota.pdf`

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    return { success: true }
  } catch (error) {
    console.log(error)
    return { success: false }
  }
}

export async function cancelarFilaLayout({ identificador, numero_nota, sequencia, codprod, observacao }) {
  try {
    const params = {
      identificador,
      numero_nota,
      sequencia,
      codprod,
      observacao,
    }

    const response = await api.post(`${process.env.REACT_APP_BASE_URL}/site/v2/fluxo-layout/cancelar-layout-pendente`, params)

    return response.data
  } catch (error) {
    console.log(error)
  }
}

export async function deletarImagensProdutos({ codigo_produto, codigo_usuario, site }) {
  const response = await api.post(
    `${process.env.REACT_APP_BASE_URL}/site/v2/fluxo-imagem/deletar-imagens-produto/${codigo_produto}/${codigo_usuario}/${site}`
  )

  return response.data
}

export async function fecharPedidoKangu({ numero_nota, nunota_origem }) {
  try {
    const response = await api.get(`${process.env.REACT_APP_BASE_URL}/site/v2/interno-devs/fechar-pedido-kangu/${numero_nota}/${nunota_origem}`)

    return response.data
  } catch (error) {
    console.log(error)
  }
}

export async function gerarBoleto({ numero_nota, numero_pedido }) {
  try {
    const response = await api.get(`${process.env.REACT_APP_BASE_URL}/site/v2/pedido/gerar-boleto-manual/${numero_nota}/${numero_pedido}`)

    return response
  } catch (error) {
    console.log(error)
  }
}

export async function limpezaCache({ codigo_produto }) {
  try {
    const response = await api.get(`${process.env.REACT_APP_BASE_URL}/site/v2/crm-controle/limpar-cache-produto/${codigo_produto}`)

    return response
  } catch (error) {
    console.log(error)
  }
}

export async function uploadImagensProdutos({ images, codigo_produto, codigo_usuario }) {
  try {
    const formData = new FormData()

    formData.append('codigo_produto', codigo_produto)
    formData.append('codigo_usuario', codigo_usuario)
    formData.append('imagem[]', images)

    const response = await api.post('/site/v2/fluxo-imagem/upload-imagens-produtos-s3', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.log(error)
    return error
  }
}

export async function verificacaoDeProdutos() {
  try {
    const response = await api.get(`${process.env.REACT_APP_BASE_URL}/site/v2/controle-crm/verifica-produtos-erro`)

    return response.data
  } catch (error) {
    console.log(error)
  }
}
